<div mat-dialog-title style="display: flex; align-items: center; gap: 10px; padding-top: 10px; margin-left: 40px">
  <div style="width: 36px; height: 36px; border-radius: 50%; background: #e8f5e9; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
    <mat-icon style="color: #2e7d32; font-size: 20px; width: 20px; height: 20px;">how_to_reg</mat-icon>
  </div>
  <div>
    <!-- <p style="font-size: 16px; font-weight: 500; margin: 0;">Session ended</p> -->
    <p style="font-size: 13px; color: #757575; margin: 0;">Impersonation has been stopped</p>
  </div>
</div>

<mat-divider></mat-divider>

<mat-dialog-content style="padding-top: 14px; padding-bottom: 8px;">
  <p style="font-size: 11px; font-weight: 500; color: #9e9e9e; text-transform: uppercase; letter-spacing: 0.6px; margin: 0 0 12px 0;">Session summary</p>

  <div style="display: flex; flex-direction: column; gap: 14px;">

    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center; gap: 7px;">
        <mat-icon style="font-size: 16px; color: #9e9e9e; width: 16px; height: 16px;">person</mat-icon>
        <span style="font-size: 13px; color: #757575;">User impersonated</span>
      </div>
      <span style="font-size: 13px; font-weight: 500; color: #212121;">{{token?.email}}</span>
    </div>

    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center; gap: 7px;">
        <mat-icon style="font-size: 16px; color: #9e9e9e; width: 16px; height: 16px;">schedule</mat-icon>
        <span style="font-size: 13px; color: #757575;">Session duration</span>
      </div>
      <span style="font-size: 13px; font-weight: 500; color: #212121;">{{data.sessionDuration}}</span>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close()">OK</button>
</mat-dialog-actions>